// removed by extract-text-webpack-plugin
module.exports = {"buyRocketModal":"_3Iwm5x-dmZtlGgi_pspQKj","buyRocketModalOverlayClassName":"_3XRxmFj4nV2pL7Qco3TeHG","buyRocketModalBody":"_2P28_30IRQQz86w32JQnai","topIcon":"_1uafBFt6si63Ln7z7jhtrD","iconTitle":"_2_4RZqX9FeYjNF12fYKRzn","title":"_2Ka57_CSkr9cJj6U37QeoN","bottomItemWrapper":"_14yM-OzbwPSqGF6seMw5xR","bottomItem":"_34UhKSP_XNTuKgkOhbIyrV"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BuyRocketPromotion/BuyRocketPromotion.scss
// module id = 1795
// module chunks = 0